import React, { useState, useRef } from 'react';
import { AddAndSearchItemContainer } from 'src/pages/reportUsage/record/components/addSearchItems/AddItemSearchItem.styled';
// import AddItemSearchItem from 'src/pages/reportUsage/record/components/addSearchItems/AddItemSearchItem';
import AddItemSearchItem from 'src/common/refactoredComponents/addItemSearchItem/AddItemSearchItem';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { localData } from 'src/pages/reportUsage/record/components/addSearchItems/LocalJsonData';
import axios from 'src/api/Api';
import Close from 'src/assets/images/CloseProduct.svg';
import {
    clearProducts,
    searchProducts,
} from 'src/pages/scheduleSurgery/redux/actions';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';

import {
    TitleContainer,
    Title,
    Icon,
    PopupContent,
    ReportUsageButtonContainer,
} from './BundleAddItemSearchItem.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import { selectedMaterialTypes } from 'src/constants/productConstants';
import { hideScrolling, resumeScrolling, logErrorToConsole } from 'src/utils/util';
import { resetBarcodeDetails } from 'src/common/barCodeScannerRedux/actions/actionCreators';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const BundleAddItemSearchItem = ({
    showModal,
    closeBundle,
    addChildProduct,
    searchedChildProduct,
    selectedBundleProduct,
    isReportPayment,
    reportPaymentGridData,
    setReportPaymentGridData,
    filteredProduct,
    setFilteredProduct,
    addItemSearchItem,
    setAddItemSearchItem,
    matchedSelectedRUBundleProduct,
    isReportUsage
}) => {
    const { t } = useTranslation();
    const [isSelected, setselected] = useState(t('reportUsage.addItems.title'));
    const [selectedProduct, setSelectedProduct] = useState({});
    const [addedProduct, setAddedProduct] = useState({});
    const [axiosSource, setAxiosSource] = useState(axios.CancelToken.source());
    const [open, setOpen] = useState(false);
    const [succesMessage, setSuccesMesssage] = useState(false);
    const [disableDoneButton, setDisableDoneButton] = useState(true);
    const popupContentRef = useRef(null);
    const savedPopupScrollTopRef = useRef(0);
    const dispatch = useDispatch();
    useEffectWithErrorLogging(() => {
        setAxiosSource(axios.CancelToken.source());
    }, []);

    useEffectWithErrorLogging(() => {
        addedProduct && showMessage(addedProduct);
    }, [addedProduct]);

    useEffectWithErrorLogging(() => {
        selectedProduct && showMessage(selectedProduct);
    }, [selectedProduct]);

    const usageDetails = useSelector(
        (state) => state.reportUsageRootReducer.usageDetails
    );

    const itemTableData = useSelector(
        (state) => state.reportUsageRootReducer.itemTableData
    );

    const bundleHeaders = usageDetails?.bundleHeaders;

    const { productsList, productListLoading } = useSelector(
        (state) => ({
            productsList: state.productsSearchReducer.isBulkUpload
                ? []
                : state.productsSearchReducer.products,
            productListLoading: state.productsSearchReducer.loading,
        }),
        shallowEqual
    );

    const matchedSelectedBundleProduct = Array.isArray(reportPaymentGridData)
        ? reportPaymentGridData.find((product) => {
              if (!product || !selectedBundleProduct) {
                  return false;
              } 
              return ((product.cfn === selectedBundleProduct.cfn) && (product.unqId === selectedBundleProduct.unqId));
          })
        : null;

    //it will get previously added product
    const previousAddedVal = (addedProduct) => {
        const ref = useRef();
        useEffectWithErrorLogging(() => {
            ref.current = addedProduct;
        });
        return ref.current;
    };

    const previous = previousAddedVal(addedProduct);

    const showMessage = (addedProduct) => {
        //checking addedProduct State is updated or not.
        if (previous != addedProduct.child && !hideSuccessMessage) {
            setSuccesMesssage({
                show: true,
                message: t(
                    'reportUsage.procedure.unidSurgery.SurgeryOrReport.itembundle'
                ),
            });
            setTimeout(() => setSuccesMesssage(false), 2000);
        }
    };

    const handleOnOpen = () => {
        if (addItemSearchItem && addItemSearchItem.trim().length >= 3) {
            setOpen(true);
        }
    };

    const handleSearchFocus = () => {
        resumeScrolling();
        if (window.innerWidth <= sizes.mobileDevice && popupContentRef.current) {
            savedPopupScrollTopRef.current = popupContentRef.current.scrollTop;
        }
    };

    const handleSearchBlur = () => {
        if (window.innerWidth <= sizes.mobileDevice) {
            resumeScrolling();
            if (popupContentRef.current) {
                const saved = savedPopupScrollTopRef.current;
                setTimeout(() => {
                    if (popupContentRef.current) {
                        popupContentRef.current.scrollTop = saved;
                    }
                }, 100);
            }
        } else {
            hideScrolling();
        }
    };

    const cancelSearchRequest = () => {
        axiosSource?.cancel('Request cancelled');
        setAxiosSource(axios.CancelToken.source());
    };
    const onSearchAddPress = (dt) => {
        setselected(dt);
        setSuccesMesssage(false);
    };

    const updateSelectedProduct = (val, reason) => {
        setHideSuccessMessage(false);
        if(reason === 'clear'){  
            setOpen(false);  
            cancelSearchRequest(); 
            setAddItemSearchItem('');
        } 

        if (reason !== 'clear' && val) {
            if (val && val.materialType === 'ZKMT') {
                searchedChildProduct({
                    parent: selectedBundleProduct,
                    child: val.cfn,
                    isBundle: true,
                }); 
            } else {
                let childProductWithS33 = isReportPayment
                    ? itemTableData[
                          selectedBundleProduct.index
                      ]?.bundleItem.filter((x) => {
                          return x?.cfn?.startsWith('S33');
                      }).length
                    : itemTableData[
                          selectedBundleProduct.index
                      ]?.children.filter((x) => {
                          return x?.cfn?.startsWith('S33');
                      }).length;
                if (
                    childProductWithS33 > 0 &&
                    val?.cfn?.toUpperCase().startsWith('S33')
                ) {
                    setSuccesMesssage({
                        show: true,
                        message: t(
                            'reportUsage.procedure.unidSurgery.SurgeryOrReport.notfound'
                        ),
                    });
                    setTimeout(() => setSuccesMesssage(false), 2000);
                    return;
                }
                searchedChildProduct({
                    parent: selectedBundleProduct,
                    child: val.cfn,
                    isBundle: false,
                });
            }
            setSelectedProduct(val.cfn);
            setDisableDoneButton(false);
        }

        if (val) {
            const updatedProductList = [...productsList];
            if (
                !updatedProductList.find((product) => val.cfn === product.cfn)
            ) {
                updatedProductList.push({ ...val, quantity: 1 });
            }
        } else {
            dispatch(clearProducts());
            setOpen(false);
            cancelSearchRequest();
        }
    };

    const autoCompleteInputChange = (e, value, reason) => {
        setHideSuccessMessage(false); 
        
        if(value){
        if (reason !== 'reset' && reason !== 'clear')
            if (value?.length >= 3 && reason !== 'reset') {
                //setSelectedProduct(value);
                setAddItemSearchItem(value);
                setOpen(true);
                dispatch(
                    searchProducts({
                        searchParam: 'productNumber',
                        searchTerm: value,
                        orderType: 'ZLB',
                        cancelSearchToken: axiosSource.token,
                        usageTerritoryId: usageDetails?.territoryId,
                    })
                );
            } else if (value.length < 3) {
                setAddItemSearchItem(value);
            }
        }
        else if(reason === 'clear'){
            setOpen(false);
            cancelSearchRequest();
            setAddItemSearchItem('');
        }  
    };

    const optionValue = 'description';

    const [hideSuccessMessage, setHideSuccessMessage] = useState(false);
    const getAddedItem = (e, isScanner = false) => {

        if (
            e.key === 'Enter' ||
            e.keyCode === 13 ||
            e.keyCode === 9 ||
            (isScanner && e?.productDetails)
        ) {
            const value = isScanner
                ? e?.productDetails?.cfn.trim().toUpperCase()
                : e.target.value.trim().toUpperCase();
            if (
                bundleHeaders
                    ?.split(',')
                    .includes(value.toUpperCase())
            ) {
                addChildProduct({
                    parent: selectedBundleProduct,
                    child: value,
                    isBundle: true,
                    isSet: false,
                    lotFromScanner: isScanner ? e : null,
                });
                setAddedProduct(value);
            } else {
                let childProductWithS33 = isReportPayment
                    ? itemTableData[
                          selectedBundleProduct.index
                      ]?.bundleItem.filter((x) => {
                          return x?.cfn?.startsWith('S33');
                      }).length
                    : itemTableData[
                          selectedBundleProduct.index
                      ]?.children.filter((x) => {
                          return x?.cfn?.startsWith('S33');
                      }).length;
                if (
                    childProductWithS33 > 0 &&
                    value.toUpperCase().startsWith('S33')
                ) {
                    setSuccesMesssage({
                        show: true,
                        message: t(
                            'reportUsage.procedure.unidSurgery.SurgeryOrReport.notfound'
                        ),
                    });
                    setTimeout(() => setSuccesMesssage(false), 2000);
                    return;
                }
                addChildProduct({
                    parent: selectedBundleProduct,
                    child: value,
                    isBundle: false,
                    isSet: false,
                    isFromBundleItemScanner: true,
                    lotFromScanner: isScanner ? e : null,
                });
                setAddedProduct(value);
            }
            setDisableDoneButton(false);
        }
        if (isScanner) {
            setHideSuccessMessage(true);
            // dispatch(resetBarcodeDetails())
        } else {
            setHideSuccessMessage(false);
        }
    };

    return (
        <>
            {showModal ? (
                <Popup
                    onClick={() => {
                        try {
                        closeBundle(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    zIndex={'99999'}
                    borderRadius={'6px'}
                    popupContentPaddingMobile={'13px'}
                    id={'reportUsage-bundleAddItemSearchItem-popup'}
                >
                    <PopupContent
                        ref={popupContentRef}
                        contentWidth={true}
                        isBulkAdd={
                            isSelected ===
                            t('scheduleSurgery.quickOrder.bulkAddText')
                        }
                        isScanItem={
                            isSelected ===
                            t('reportUsage.searchItems.ScanItems')
                        }
                    >
                        <TitleContainer>
                            <Title style={{ margin: 0 }}>
                                {`${t(
                                    'templates.common.addItemBundlePop.itemsBundle'
                                )} : ${selectedBundleProduct.cfn}`}
                            </Title>
                            <Icon
                                id="bundle-add-item-popup-close-icon"
                                mobilePath={Close}
                                onClick={() => {
                                    try {
                                    closeBundle(false);
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                show={true}
                            />
                        </TitleContainer>

                        <AddAndSearchItemContainer
                            width={'100%'}
                            style={{ paddingTop: '18px' }}
                            boxShadow={'none'}
                            marginLeft={'none'}
                            marginLeftInput={'none'}
                            padding={'6px !important'}
                        >
                            <AddItemSearchItem 
                                id='reportUsage-bundle'
                                addItemSearchTerm={addItemSearchItem}
                                isBundleScanItem={
                                    isSelected ===
                                    t('reportUsage.searchItems.ScanItems')
                                }
                                buttonList={localData().searchAddButton}
                                onSearchAddPress={onSearchAddPress}
                                isSelected={isSelected}
                                addItemPlaceholder={t(
                                    'reportUsage.addItems.enterCfnOrItemNumber'
                                )}
                                autoCompleteData={productsList}
                                autoCompleteDataLoading={productListLoading}
                                optionValue={
                                    productsList &&
                                    productsList.every((x) =>
                                        selectedMaterialTypes?.includes(
                                            x.materialType
                                        )
                                    )
                                        ? 'cfn'
                                        : optionValue
                                }
                                optionLabelKey={''}
                                autoCompletePlaceholder={t(
                                    'reportUsage.searchItems.searchByItemNameorNumber'
                                )}
                                autoCompleteInputChange={
                                    autoCompleteInputChange
                                }
                                onClose={() => {
                                    try {
                                    setOpen(false);
                                    cancelSearchRequest();
                                    setAddItemSearchItem('');
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                setOpen={setOpen}   
                                onChange={updateSelectedProduct}
                                handleOnOpen={handleOnOpen}
                                open={open}
                                addItemChange={getAddedItem}
                                succesMessage={succesMessage}
                                zIndex={99999}
                                fontSize={'14px'}
                                fontFamily={'AvenirNextWorld Regular'}
                                color={'#040404'}
                                opacity={'0.9'}
                                handleFocus={handleSearchFocus}
                                handleBlur={handleSearchBlur}
                                dropdownHeight={
                                    window.innerWidth <= sizes.mobileDevice &&
                                    '200px'
                                }
                                showScrollBar={
                                    window.innerWidth <= sizes.mobileDevice &&
                                    false
                                }
                                isBundle={true}
                                selectedBundleProduct={selectedBundleProduct}
                                setDisableDoneButton={setDisableDoneButton}
                                isReportPayment={isReportPayment}
                                setSuccesMesssage={setSuccesMesssage}
                                reportPaymentGridData={reportPaymentGridData}
                                setReportPaymentGridData={
                                    setReportPaymentGridData
                                }
                                filteredProduct={filteredProduct}
                                setFilteredProduct={setFilteredProduct}
                                productSelectedItem={
                                    isReportUsage? matchedSelectedRUBundleProduct :
                                    matchedSelectedBundleProduct}
                                isBundleProduct
                                checkLotSerial
                            />
                        </AddAndSearchItemContainer>
                        {window.innerWidth <= sizes.mobileDevice ? (
                            <ReportUsageButtonContainer
                                smallJustifyContent={'center'}
                                justifyContent={''}
                                padding={'11px 21px'}
                                position={'absolute'}
                                bottom={'13px'}
                                right={'13px'}
                            >
                                <Button
                                    id={'reportUsage-record-addButton'}
                                    show={true}
                                    // primary={!disableDoneButton}
                                    variant={!disableDoneButton ? ButtonStyles?.primary : ButtonStyles.disabled}
                                    width={'162px'}
                                    // mobileWidth={'102px'}
                                    height={'38px'}
                                    minWidth={'162px'}
                                    // fontSize={'15px'}
                                    clicked={() => {
                                        try {
                                            closeBundle(false);
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    disabled={disableDoneButton}
                                >
                                    {t('reportUsage.bundleComplete')}
                                </Button>
                            </ReportUsageButtonContainer>
                        ) : (
                            <BottomNavigation
                                justifyContent="space-around"
                                moblieJustifyContent="flex-end"
                                padding={'10px'}
                                inPaddingVertical={'11px 0px 11px 0px'}
                                right={'0'}
                                position={'absolute'}
                                mbPosition={'absolute'}
                            >
                                <ReportUsageButtonContainer
                                    smallJustifyContent={'center'}
                                    justifyContent={''}
                                    padding={'11px 21px'}
                                >
                                    <Button
                                      id={'reportUsage-record-addSearchItem-addButton'}
                                        show={true}
                                        // primary={!disableDoneButton}
                                         variant={!disableDoneButton ? ButtonStyles?.primary : ButtonStyles.disabled}
                                        width={'162px'}
                                        mobileWidth={'102px'}
                                        minWidth={'162px'}
                                        height={'38px'}
                                        // fontSize={'15px'}
                                        clicked={() => {
                                            try {
                                            closeBundle(false);
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                        disabled={disableDoneButton}
                                    >
                                        {t('reportUsage.bundleComplete')}
                                    </Button>
                                </ReportUsageButtonContainer>
                            </BottomNavigation>
                        )}
                    </PopupContent>
                </Popup>
            ) : null}
        </>
    );
};
export default BundleAddItemSearchItem;
